import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "@/components/ui/select";
import { Search, Star } from "lucide-react";

const STATUSES = [
  "Recebida", "Em Triagem", "Documentação Pendente",
  "Em Análise", "Aprovada", "Indeferida", "Homologada",
];

export default function InscricoesFilters({
  q, setQ, bairro, setBairro, status, setStatus, onFiltrar,
  canDossie, favoritesOnly, setFavoritesOnly,
}) {
  return (
    <Card>
      <CardHeader><CardTitle className="text-base">Filtros</CardTitle></CardHeader>
      <CardContent>
        <div className="grid md:grid-cols-4 gap-3">
          <Input placeholder="Nome, CPF (parcial), NIS, protocolo..." value={q} onChange={(e) => setQ(e.target.value)} data-testid="filtro-q" />
          <Input placeholder="Bairro" value={bairro} onChange={(e) => setBairro(e.target.value)} data-testid="filtro-bairro" />
          <Select value={status} onValueChange={setStatus}>
            <SelectTrigger data-testid="filtro-status"><SelectValue placeholder="Status" /></SelectTrigger>
            <SelectContent>
              <SelectItem value="all">Todos</SelectItem>
              {STATUSES.map((s) => <SelectItem key={s} value={s}>{s}</SelectItem>)}
            </SelectContent>
          </Select>
          <Button onClick={onFiltrar} className="bg-[#083CA6] hover:bg-[#062f85]" data-testid="btn-filtrar">
            <Search className="w-4 h-4 mr-2" />Filtrar
          </Button>
        </div>
        {canDossie && (
          <div className="mt-3 flex items-center gap-2">
            <Button
              size="sm"
              variant={favoritesOnly ? "default" : "outline"}
              className={favoritesOnly ? "bg-amber-500 hover:bg-amber-600 text-white border-amber-500" : "border-amber-300 text-amber-700 hover:bg-amber-50"}
              onClick={() => setFavoritesOnly((v) => !v)}
              data-testid="btn-toggle-favorites-only"
            >
              <Star className={`w-4 h-4 mr-1.5 ${favoritesOnly ? "fill-current" : ""}`} />
              {favoritesOnly ? "Mostrando só favoritas" : "Só favoritas"}
            </Button>
            <span className="text-xs text-slate-500">Favoritas aparecem no topo da lista automaticamente.</span>
          </div>
        )}
      </CardContent>
    </Card>
  );
}
